import Vue from 'vue'

export default Vue.extend({
  name: 'html-fragment',
  functional: true,
  props: {
    html: {
      type: String,
      required: true,
    },
  },
  render(h, ctx) {
    return new Vue({
      beforeCreate() {
        this.$createElement = h
      }, // not necessary, but cleaner imho
      template: `<div>${ctx.props.html}</div>`,
    }).$mount()._vnode.children
  },
})
